import "./public.path";
import "babel-polyfill";
import React from "react";
import {render} from "react-dom";
import {Provider} from "react-redux";
import configureStore from "./store/index";
import "./styles/common";
import App from "./App";

const store = configureStore({
	Config: window.config,
	Project: window.project,
	pageName: window.pageName,
	pages: window.pages,
	Client: window.client,
});

window.store = store;

render(<Provider store={store}><App /></Provider>, document.getElementById('root'));
